import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { Tag } from 'primeng/tag';
import { AbstractComponent } from '@spike/scaffolds';
import { Button } from "primeng/button";
import { EntityEtiquette } from '../../models/entity-etiquette.model';

@Component({
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'spike-etiquette',
  providers:[],
  imports: [Button],
  templateUrl: './etiquette.html'
})
export class EtiquetteComponent extends AbstractComponent{
  etiquette = input<EntityEtiquette>();
  label = input<string>();
  severity = input.required<'info' | 'secondary' | 'success' |'contrast'>();

  
}